// Shift dates are org-local "YYYY-MM-DD" strings, so a plain string compare
// filters them. An empty end of the range is unbounded.
export const notesInRange = (rows, from, to) => rows.filter((r) => {
  const d = String(r.shift_date || "").slice(0, 10);
  return (!from || d >= from) && (!to || d <= to);
});

// What a note counts as in an export: a Submitted note on an approved timesheet
// is Approved (the server sets export_status). Drafts are never exported.
export const EXPORT_STATUSES = ["Approved", "Submitted", "Returned"];
export const exportStatus = (r) => r.export_status || r.status || "Draft";

export const notesForExport = (rows, from, to, statuses) =>
  notesInRange(rows, from, to).filter((r) => statuses.includes(exportStatus(r)));
